import { history } from "../../Configs/history/history";
import { AppRoutes } from "../../Core/App/AppRoutes";
import { INavigationService } from "../../Core/Services/Interfaces/INavigationService";

//* Generic detail route
export const getDetailsRoute = (id: string, detailsRoute: string): string => `${detailsRoute}`.replace(":id", id);

export const getProgramDetailsRoute = (programId: string, id: string, detailsRoute: string): string =>
  `${detailsRoute}`.replace(":programid", programId).replace(":id", id);

export const getRefundDetailsRoute = (refundId: string, id: string, detailsRoute: string): string =>
  `${detailsRoute}`.replace(":refundId", refundId).replace(":id", id);

export const getProgramLotDetailsRoute = (programId: string, lotid: string, id: string, detailsRoute: string): string =>
  `${detailsRoute}`.replace(":programid", programId).replace(":lotid", lotid).replace(":id", id);

export class NavigationService implements INavigationService {
  private state: { routeList: Array<string> };

  constructor() {
    this.state = { routeList: [] };
    history.listen(this.listen);
  }

  public getHomeLink = AppRoutes.DEFAULT;

  public goTo = (route: string, replace?: boolean): void => {
    if (replace) {
      history.replace(route);
    } else {
      history.push(route);
    }
  };

  public goToHome = (): void => history.push(this.getHomeLink);
  public goBack = (): void => history.goBack();
  public goToLogin = (): void => history.push(AppRoutes.LOGIN);
  public getPreviousRoute = (): string => {
    if (this.state.routeList.length >= 2) {
      return this.state.routeList[this.state.routeList.length - 2];
    } else {
      return '';
    }
  }

  public goToWorkerList = (): void => history.push(AppRoutes.WORKER_LIST);
  public goToWorkerDetails = (id: string): void =>
      history.push(getDetailsRoute(id, AppRoutes.WORKER_DETAILS));
  public getWorkerDetails = (id: string): string => getDetailsRoute(id, AppRoutes.WORKER_DETAILS);

  public listen = (action: any) => {
    this.state.routeList.push(action.pathname);
  };
}
